export default __webpack_public_path__ + "img/Montserrat-ExtraLight_da136e9.eot";